/* eslint-disable-next-line @typescript-eslint/no-restricted-imports -- (https://aka.ms/OWALintWiki)
 * Make sure this isn't imported in the analytics worker
 *	> 'owa-local-storage' import is restricted from being used. localStorage is not available in the analytics worker [analytics-worker-lint] */
import { setItem, getItem } from 'owa-local-storage';
import type { LogicalRing } from 'owa-config-types';

const LogicalRingKey = 'LogicalRing';

let logicalRing: LogicalRing | null;
const logicalRingByAccount = new Map<string, LogicalRing>();

export function setLogicalRing(ring: LogicalRing, accountKey?: string): void {
    if (accountKey) {
        if (logicalRingByAccount.get(accountKey) === ring) {
            return;
        }
        logicalRingByAccount.set(accountKey, ring);
        setItem(self, `${LogicalRingKey}_${accountKey}`, ring);
        return;
    }

    if (!!logicalRing && logicalRing === ring) {
        return;
    }
    logicalRing = ring;
    setItem(self, LogicalRingKey, ring);
}

export function getLogicalRing(accountKey?: string): LogicalRing | null {
    if (accountKey) {
        let ring = logicalRingByAccount.get(accountKey);
        if (!ring) {
            ring =
                (getItem(self, `${LogicalRingKey}_${accountKey}`) as LogicalRing | null) ??
                undefined;
        }
        return ring ?? null;
    }

    if (!logicalRing) {
        logicalRing = getItem(self, LogicalRingKey) as LogicalRing | null;
    }

    return logicalRing;
}
